import React from 'react';
type PrimaryButtonProps = {
  label: string;
  href?: string;
  target?: '_self' | '_top' | '_blank';
  onClick?: () => void;
  className?: string;
};
const baseClass = 'inline-flex h-14 items-center justify-center whitespace-nowrap rounded-full bg-carbon px-8 text-base font-medium text-ivory transition-[background-color,transform] duration-150 ease-out hover:bg-[#2b2b2b] active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ivory';
export function PrimaryButton({
  label,
  href,
  target,
  onClick,
  className = ''
}: PrimaryButtonProps) {
  if (href) {
    return <a href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} className={`${baseClass} ${className}`} data-id="element-149" data-mp="2ef09qgvm9foi">
        {label}
      </a>;
  }
  return <button type="button" onClick={onClick} className={`${baseClass} ${className}`} data-id="element-150" data-mp="p26le2tlg5ys">
      {label}
    </button>;
}